<kendo-splitter class="padding">

    <kendo-splitter-pane class="style-splitter" size="54%">
        <div style="height:100%;">
            <kendo-grid class="k-grid k-grid-header custom2" style="height:100%;" [kendoGridBinding]="displayCompanies"
                kendoGridSelectBy="companyId" [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}"
                [loading]="companiesLoading" [sortable]="true" [size]="smallSize" [resizable]="true"
                (cellClick)="onCellClick($event)" scrollable="virtual" [pageSize]="pageSize" [style.height.%]="100"
                [rowHeight]="15" [filterable]="false" (excelExport)="onExcelExport($event)">
                <ng-template kendoGridToolbarTemplate>
                         <input type="text" class="kendo-like-input" placeholder="Search on Company Name or Recipient Code"
                        [(ngModel)]="searchTerm" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilter($event)" kendoGridToolbarFocusable />
                    <kendo-grid-spacer></kendo-grid-spacer>
                    <button kendoGridExcelCommand class="allbuttons" [svgIcon]="excelSVG">
                        Export
                    </button>
                </ng-template>
                <kendo-grid-column field="companyId" title="ID" [width]="50"></kendo-grid-column>
                <kendo-grid-column field="companyName" title="Company Name" [width]="190"></kendo-grid-column>
                <kendo-grid-column field="recipientCode" title="Recipient Code" [width]="125"></kendo-grid-column>
                <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
            </kendo-grid>
        </div>
    </kendo-splitter-pane>
    <kendo-splitter-pane>
        <form class="k-form k-form-md" [formGroup]="form">
            <div style="width:450px;">
                <button class="adminbutton allbuttons" kendoButton (click)="onAddButtonClick()"
                    [disabled]="addbuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[0]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Add</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onRemoveButtonClick()" [disabled]="removebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[1]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Remove</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onSaveButtonClick()" [disabled]="savebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[2]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Save</div>
                    </div>
                </button>
                <!-- [disabled]="uploadbuttonstate" -->
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton (click)="onExcelClick()"
                    [disabled]="uploadbuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[8]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Upload</div>
                    </div>
                </button>
            </div>

            <div class="wrap1">
                <kendo-formfield>
                    <kendo-label class="label" #companyId id="companyId" [for]="companyId" text="ID"></kendo-label>
                    <kendo-textbox [style.width.px]="90" class="readonly" formControlName="companyId"
                        [readonly]="true"></kendo-textbox>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-label class="label" #companyName id="companyName" [for]="companyName"
                        text="Company Name"></kendo-label>
                    <kendo-textbox [style.width.px]="400" #companyname class="class-id" formControlName="companyName"
                        [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                </kendo-formfield>
                <kendo-formfield>
                    <kendo-label class="label" #address id="address" [for]="address" text="Address"></kendo-label>
                    <kendo-textbox [style.width.px]="400" class="class-id" formControlName="address"
                        [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                </kendo-formfield>

                <kendo-formfield>
                    <kendo-label class="label" #city id="city" [for]="address" text="City"></kendo-label>
                    <kendo-textbox [style.width.px]="400" class="class-id" formControlName="city" [readonly]="readonly"
                        (valueChange)="valueChange($event)"></kendo-textbox>
                </kendo-formfield>
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #state id="state" [for]="address" text="State"></kendo-label>
                        <kendo-textbox [style.width.px]="200" class="class-id" formControlName="state"
                            [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                    </kendo-formfield>
                    <div>
                        <kendo-formfield>
                            <kendo-label class="label" #zip id="zip" [for]="zip" text="ZIP"></kendo-label>
                            <kendo-textbox [style.width.px]="170" class="class-id" formControlName="zip"
                                [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                        </kendo-formfield>
                    </div>
                </div>
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #phone id="phone" [for]="phone" text="Phone"></kendo-label>
                        <kendo-textbox [style.width.px]="200" class="class-id" formControlName="phone"
                            [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-label class="label" #recipientCode id="recipientCode" [for]="phone"
                            text="Recipient Code"></kendo-label>
                        <kendo-textbox [style.width.px]="170" class="class-id" formControlName="recipientCode"
                            [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                    </kendo-formfield>
                </div>
            </div>
        </form>
    </kendo-splitter-pane>
</kendo-splitter>

<div>
    <kendo-window title={{windowTitle}} *ngIf="openedexcelwindow" (close)="closeExcelWindow()" [width]="850"
        [height]="410" [resizable]="false" [top]="0" [left]="30">
        <br>
        <div id="spreadsheet">
            <kendo-spreadsheet [sheets]="exceldata" #spreadsheet style="height: 250px !important; width: 100%"
                [rowHeight]="20" [headerHeight]="10" [columns]="7" [menuItems]="items">
            </kendo-spreadsheet>
        </div>
        <div class="k-actions k-actions-end blue">

            <button class="blue" class="allbuttons" kendoButton type="button"
                (click)="closeExcelWindow()">Cancel</button>
            <button class="blue" class="allbuttons" kendoButton type="button"
                (click)="saveExcelSample(spreadsheet)">Validate</button>
        </div>
        <span class="blue" style="font-size: small;font-style: italic;text-align: left;"> *Comapny Name is mandatory,
            empty fields need a dash '-'</span>
        <div class="k-dialog-content">
            <ng-container kendoDialogContainer></ng-container>
        </div>
    </kendo-window>
</div>

<kendo-dialog *ngIf="showErrorDialog" (close)="showErrorDialog = false">
    <kendo-dialog-titlebar>
        Error
    </kendo-dialog-titlebar>
    <p>{{ errorMessage }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="showErrorDialog = false">OK</button>
    </kendo-dialog-actions>
</kendo-dialog>
<kendo-window [title]="title" *ngIf="errorWindow" [width]="500" [height]="250" [top]="20" [draggable]="true"
    [resizable]="true" (close)="errorWindow = false">
    <div class="error-dialog-content">
        <div class="error-text-container">
            <pre class="error-text-block">{{ content }}</pre>
        </div>
        <kendo-dialog-actions>
            <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
                (click)="copyToClipboard();success('Ready to paste in Excel')">Copy for Excel</button>
            <button kendoButton style="height: 30px;background-color: #1825aa;color: white"
                (click)="errorWindow = false">Cancel</button>
        </kendo-dialog-actions>
    </div>
</kendo-window>